<template>
    <div class="platform-management row">
      
      <!-- Platform Listesi -->
      <div class="col-12 col-md-8">
        <b-card>
          <h4 class="mb-3">Platform Yönetimi</h4>
          <b-table
            :items="platforms"
            :fields="fields"
            bordered
            responsive
            hover
          >
            <template #cell(actions)="row">
              <b-button
                size="sm"
                variant="primary"
                class="mr-1"
                @click="editPlatform(row.item)"
              >
                <feather-icon icon="Edit2Icon" title="Düzenle" />
              </b-button>
              <b-button
                size="sm"
                variant="danger"
                @click="deletePlatform(row.item.id)"
                v-if="isDeveloper"
              >
                <feather-icon icon="Trash2Icon" title="Sil" />
              </b-button>
            </template>
            <template #cell(default)="row">
              <b-form-checkbox
                v-model="row.item.default"
                :disabled="row.item.default" 
                @change="updatePlatform(row.item, true)"
              >
                Varsayılan
              </b-form-checkbox>
            </template>
            <template #cell(status)="row">
              <b-form-checkbox
                v-model="row.item.status"
                @change="updatePlatform(row.item)"
              >
              <b-badge pill variant="success" v-if="row.item.status">Aktif</b-badge>
              <b-badge pill variant="danger" v-else>Pasif</b-badge>
              </b-form-checkbox>
            </template>
          </b-table>
        </b-card>
      </div>
  
      <!-- Platform Ekle/Düzenle -->
      <div class="col-12 col-md-4">
        <b-card>
          <h4 class="mb-3">{{ isEditing ? 'Platform Düzenle' : 'Yeni Platform Ekle' }}</h4>
          <b-form @submit.prevent="isEditing ? updatePlatform(newPlatform) : addPlatform()">
            <b-form-group label="Platform Adı" label-for="platform-name">
              <b-form-input
                id="platform-name"
                v-model="newPlatform.name"
                required
                placeholder="Platform adı giriniz"
              />
            </b-form-group>
            <b-form-group label="Platform Değeri" label-for="platform-value">
              <b-form-input
                id="platform-value"
                v-model="newPlatform.value"
                required
                placeholder="Platform değeri giriniz"
              />
            </b-form-group>
            <b-form-group label="Platform Kısa Link" label-for="platform-short_code">
              <b-form-input
                id="platform-short_code"
                v-model="newPlatform.short_code"
                required
                placeholder="Platform değeri giriniz"
              />
            </b-form-group>
            
            <b-button type="submit" :variant="isEditing ? 'primary' : 'success'" block>
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </b-button>
            <b-button
              type="button"
              variant="danger"
              block
              @click="resetForm"
            >
              Vazgeç
            </b-button>
          </b-form>
        </b-card>
      </div>
    </div>
  </template>
  <script>
  import {
    BButton,
    BCard,
    BForm,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BTable,
    BBadge,
    BSidebar
  } from 'bootstrap-vue';
  import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
  export default {
    name: 'PlatformManagement',
    components: {
      BButton,
      BCard,
      BForm,
      BFormInput,
      BFormGroup,
      BFormCheckbox,
      BTable,
      FeatherIcon,
      BBadge,
      BSidebar
    },
    data() {
      return {
        platforms: [], // Platform listesi
        fields: [
          { key: 'name', label: 'Platform Adı' },
          { key: 'value', label: 'Platform Değeri' },
          { key: 'status', label: 'Durum' },
          { key: 'default', label: 'Varsayılan', sortable: false },
          { key: 'short_code', label: 'Kısa link', sortable: false },
          { key: 'actions', label: 'İşlemler', sortable: false },
        ],
        newPlatform: {
          id: null,
          name: '',
          value: '',
          default: false,
          short_code: null,
        },
        isEditing: false,
        sideBarTest: false,
      };
    },
    created() {
      this.fetchPlatforms();
    },
    methods: {
      async fetchPlatforms() {
        try {
          const response = await this.$http.get('/platforms', { params: { source: 'list' } });
          this.platforms = response.data.data.map(platform => ({
            ...platform,
            default: platform.default === 1,
            status: platform.status === 1,
          }));
        } catch (error) {
          console.error('Platformlar yüklenirken bir hata oluştu:', error);
        }
      },
      async addPlatform() {
        try {
          const response = await this.$http.post('/platforms', this.newPlatform);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Platform Eklendi',
              icon: 'CheckIcon',
              variant: 'success',
              text: `Yeni platform başarıyla eklendi.`,
            },
          });
          this.platforms.push(response.data);
          this.resetForm();
        } catch (error) {
          console.error('Platform eklenirken bir hata oluştu:', error);
        }
      },
      editPlatform(platform) {
        this.isEditing = true;
        this.newPlatform = { ...platform };
      },
      async updatePlatform(platform, isDefaultUpdate = false) {
        try {
          // Eğer varsayılan güncelleniyorsa diğer platformların varsayılanını sıfırla
          if (isDefaultUpdate && platform.default) {
            this.platforms.forEach(p => {
              if (p.id !== platform.id) {
                p.default = false;
              }
            });
          }
  
          await this.$http.put(`/platforms/${platform.id}`, platform);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Platform Güncellendi',
              icon: 'Edit2Icon',
              variant: 'primary',
              text: `Platform başarıyla güncellendi.`,
            },
          });
  
          const index = this.platforms.findIndex(p => p.id === platform.id);
          if (index !== -1) {
            this.$set(this.platforms, index, { ...platform });
          }
  
          if (!isDefaultUpdate) {
            this.resetForm();
          }
        } catch (error) {
          console.error('Platform güncellenirken bir hata oluştu:', error);
        }
      },
      async deletePlatform(id) {
        if (!confirm('Bu platformu silmek istediğinize emin misiniz?')) return;
        try {
          await this.$http.delete(`/platforms/${id}`);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Platform Silindi',
              icon: 'Trash2Icon',
              variant: 'danger',
              text: `Platform başarıyla silindi.`,
            },
          });
          this.platforms = this.platforms.filter(p => p.id !== id);
        } catch (error) {
          console.error('Platform silinirken bir hata oluştu:', error);
        }
      },
      resetForm() {
        this.newPlatform = {
          id: null,
          name: '',
          value: '',
          default: false,
        };
        this.isEditing = false;
      },
    },
  };
  </script>